import {
  MockMap,
} from '@ama-sdk/core';
import {
  createMockData,
} from '@dapi/sdk/spec';
import {
  acknowledgeSuccess,
  retrieveOrderMockEligibleAcknowledgeOnly,
} from '../../../mock/data/index';

export const eligibleToAcknowledgeOnlyMock: MockMap = {
  retrieveOrder: [
    {
      mockData: retrieveOrderMockEligibleAcknowledgeOnly
    }
  ],
  getOrderEligibilities: [],
  acknowledge: [createMockData(acknowledgeSuccess)]
};
